module.exports = __webpack_public_path__ + "16695b183e1839f983e9f7ca1f8952c1.svg";